import { useBlockProps, InnerBlocks, InspectorControls, BlockControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { useEffect, useState, useRef } from '@wordpress/element';
import { useSelect, useDispatch } from '@wordpress/data';
import { PanelBody,Button, SelectControl, ToolbarButton } from '@wordpress/components';
import './editor.scss';
import { usePanelSettings } from '@vayu-blocks';
const ALLOWED_BLOCKS_PIN = ['vayu-blocks/advance-container','vayu-blocks/advance-heading']; // Allowed inside the pin

const panelKeys = [
	'pin-set',	
];


const initialPanels = {
	setting: 'pin-set',
	style: '',
	advanced: '',
};

export default function Edit(props) {
    
    const {
		attributes,
		setAttributes,
		clientId,
	} = props;

    const { id } = attributes;

    if (!attributes.uniqueId) {
        setAttributes({ uniqueId: clientId });
    }

    if (!id) {
        setAttributes({ id: clientId });
    }

    const { x = 50, y = 50, tooltipDisplay = 'onHover' } = attributes; // Default position in the center
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = (event) => {
        // Allow selection of child blocks
        
        setIsDragging(true);

        const handleMouseMove = (moveEvent) => {
            const container = moveEvent.target.closest('.vb-image-wrapper');
            if (!container) return;

            const rect = container.getBoundingClientRect();
            const newX = ((moveEvent.clientX - rect.left) / rect.width) * 100;
            const newY = ((moveEvent.clientY - rect.top) / rect.height) * 100;

            setAttributes({ x: newX, y: newY });
        };

        const handleMouseUp = () => {
            setIsDragging(false);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    // const handleAddPin = () => {
    //     if (parentClientId) {
    //         const newPinBlock = wp.blocks.createBlock('vayu-blocks/pin', { x: 50, y: 50 });
    //         wp.data.dispatch('core/block-editor').insertBlock(newPinBlock, undefined, parentClientId);
    //     }
    // };

 
      // Get the Image block's clientId (parent of Pin block)
      const imageBlockId = useSelect((select) => {
        const { getBlockParents, getBlock } = select('core/block-editor');
        const parentIds = getBlockParents(clientId);
        if (parentIds.length > 0) {
            const imageBlock = parentIds
                .map((id) => getBlock(id))
                .find((block) => block.name === 'vayu-blocks/image'); // Find the Image block
            return imageBlock?.clientId || null;
        }
        return null;
    }, [clientId]);

    // Set the Image block clientId attribute in the Pin block
    useEffect(() => {
        if (imageBlockId) {
            setAttributes({ parentBlock: imageBlockId });
        }
    }, [imageBlockId]);

    const { insertBlock } = useDispatch('core/block-editor');

    const handleAddPin = () => {
        if (imageBlockId) {
            const newPinBlock = wp.blocks.createBlock('vayu-blocks/pin', { x: 50, y: 50 });
            insertBlock(newPinBlock, undefined, imageBlockId); // Insert pin inside the Image block
        } else {
            console.error(__('No parent Image block found to insert the pin.', 'vayu-blocks'));
        }
    };

    const handleDeletePin = () => {
        wp.data.dispatch('core/block-editor').removeBlock(clientId); // Remove the current block
    };

    // ******************* TooltipTriangle Arrow Start ************************* 
       // To get attributes od container blocks rendering through inner block
    const containerBlockAttributes = useSelect((select) => {
        const { getBlock } = select('core/block-editor');
        const innerBlocks = getBlock(clientId)?.innerBlocks || [];
    
        // Find the advance-container block
        const containerBlock = innerBlocks.find(
            (block) => block.name === 'vayu-blocks/advance-container'
        );
    
        return containerBlock?.attributes || {};
    }, [clientId]);

    const containerBackgroundColor = containerBlockAttributes?.advBackground?.color || '#444942';

    useEffect(() => {
        if (containerBackgroundColor && containerBackgroundColor !== attributes.triangleArrowColor) {
            setAttributes({ triangleArrowColor: containerBackgroundColor });
        }
    }, [containerBackgroundColor]);
    

    const blockRef = useRef(); // Ref for the root container elemen

    useEffect(() => {
        if (blockRef.current) {
            // Function to append and style the triangle arrow
            const appendTriangleArrow = (containerDiv) => {
                // Ensure each container has its own triangle
                let triangleDiv = containerDiv.querySelector('.triangle-arrow');
                if (!triangleDiv) {
                    triangleDiv = document.createElement('div');
                    triangleDiv.className = 'triangle-arrow';
                    containerDiv.appendChild(triangleDiv);
                }
    
                // Get the position and dimensions of the current container
                const containerRect = containerDiv.getBoundingClientRect();
    
                // Set styles for the triangle arrow
                triangleDiv.style.cssText = `
                    position: absolute;
                    width: 0;
                    height: 0;
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-top: 10px solid ${containerBackgroundColor};
                `;
            };
    
            // Handle existing `.vayu-pin-first-wrap` elements
            const containerDivs = blockRef.current.querySelectorAll('.vayu-pin-first-wrap');
            containerDivs.forEach((containerDiv) => appendTriangleArrow(containerDiv));
    
            // Observe changes to dynamically added `.vayu-pin-first-wrap` elements
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        mutation.addedNodes.forEach((node) => {
                            if (node.classList?.contains('vayu-pin-first-wrap')) {
                                appendTriangleArrow(node);
                            }
                        });
                    }
                });
            });
    
            observer.observe(blockRef.current, { childList: true, subtree: true });
    
            // Cleanup observer on unmount
            return () => {
                observer.disconnect();
            };
        } else {
            console.warn('Block reference not found');
        }
    }, [blockRef, containerBackgroundColor]);


       // ******************* TooltipTriangle Arrow End ************************* 

    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    useEffect(() => {
        const parentContainer = document.querySelector('.vayu_blcoks_icon_main_blocks_icon');

        const handleClick = (e) => {
            e.stopPropagation();

            // Check if the clicked element is an SVG within the target class
            if (e.target.closest('.vayu_blocks_icon_block_main_icon_svg svg')) {
                const svgElement = e.target.closest('.vayu_blocks_icon_block_main_icon_svg svg');
                const wrapper = svgElement.closest('.vayu-pin-spot-wrapper7');

                if (wrapper) {
                    // Toggle the visibility class
                    wrapper.classList.toggle('is-tooltip-visible');
                }
            }
        };

        // Attach the event listener to the parent container
        if (parentContainer) {
            parentContainer.addEventListener('click', handleClick);
        }
        
        // Cleanup event listener on component unmount
        return () => {
            if (parentContainer) {
                parentContainer.removeEventListener('click', handleClick);
            }
        };
    }, []); // Empty dependency array ensures this runs once after component mounts

    const blockProps = useBlockProps({
        ref: blockRef, 
        id: attributes.uniqueId,
        className: 'vayu-pin-block',
        style: {
            position: 'absolute',
            top: `${y}%`,
            left: `${x}%`,
            transform: 'none',
            // cursor: isDragging ? 'grabbing' : 'grab',
            cursor: 'move',
            zIndex: 108
        },
        onMouseDown: (event) => handleMouseDown(event),
        // onMouseUp: (event) => handleMouseUp(event),
    });  

    const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'setting' });

    return (
        <>

            <BlockControls>
                <ToolbarButton
                    icon="plus"
                    label={__('Add Pin', 'vayu-blocks')}
                    onClick={handleAddPin}
                />
                <ToolbarButton
                    icon="trash"
                    label={__('Remove This Pin', 'vayu-blocks')}
                    onClick={handleDeletePin}
                    isDestructive
                />
            </BlockControls>

            <InspectorControls>
                <PanelBody title={__('Pin Settings', 'vayu-blocks')}
                    opened={openPanels['pin-set']} onToggle={() => onTogglePanel('pin-set')} >
                    <Button className='add-pin' isSecondary onClick={handleAddPin}>
                        {__('Add Pin', 'vayu-blocks')}
                    </Button>
                    <Button className='delete-pin' isDestructive isSecondary onClick={handleDeletePin}>
                        {__('Remove This Pin', 'vayu-blocks')}
                    </Button>

                    <SelectControl
                        label={__('Tooltip Display', 'vayu-blocks')}
                        value={tooltipDisplay}
                        options={[
                            { label: __('On Hover', 'vayu-blocks'), value: 'onHover' },
                            { label: __('On Click', 'vayu-blocks'), value: 'onClick' },
                            { label: __('Always Visible', 'vayu-blocks'), value: 'alwaysVisible' },
                        ]}
                        onChange={(value) => setAttributes({ tooltipDisplay: value })}
                    />
                </PanelBody>
            </InspectorControls>

            
        <div {...blockProps}>
            {/* vayu-pin-spot-wrapper for Tooltip Visibility */}
            <div className={`vayu-pin-spot-wrapper7 tooltip-${tooltipDisplay}`}
                style={{ position: 'relative' }}
                onMouseEnter={() => {
                    if (tooltipDisplay === 'onHover') setIsTooltipVisible(true);
                }}
                onMouseLeave={() => {
                    if (tooltipDisplay === 'onHover') setIsTooltipVisible(false);
                }}
            >
                {/* Tooltip (vayu-blocks/advance-heading) will be shown when hovering over the icon */}
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS_PIN}
                    template={[
                        ['vayu-blocks/advance-container',{
                            contentWidthType: 'fullwidth',
                            fullcontentWidth: {
                                Desktop: '63px',
                                Tablet: '63px',
                                Mobile: '63px',
                            },
                            advBackground: {
                                type: 'color',
                                color: '#444942',
                                image: {
                                    url: ''
                                },
                                gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                              },
                              advPadding: {
                                Desktop: {
                                  top: '5px',
                                  right: '12px',
                                  bottom: '5px',
                                  left: '12px',
                                },
                                Tablet: {
                                    top: '5px',
                                    right: '12px',
                                    bottom: '5px',
                                    left: '12px',
                                },
                                Mobile: {
                                    top: '5px',
                                    right: '12px',
                                    bottom: '5px',
                                    left: '12px',
                                },
                              },
                              advBorderRadius: {
                                Desktop: {
                                  topLeft: '5px',
                                  topRight: '5px',
                                  bottomLeft: '5px',
                                  bottomRight: '5px',
                                },
                                Tablet: {
                                    topLeft: '5px',
                                    topRight: '5px',
                                    bottomLeft: '5px',
                                    bottomRight: '5px',
                                },
                                Mobile: {
                                    topLeft: '5px',
                                    topRight: '5px',
                                    bottomLeft: '5px',
                                    bottomRight: '5px',
                                },
                              },
                              advPosition: {
                                value: 'absolute',
                                horiori: 'right',
                                offsetright: {
                                  Desktop: '-9px',
                                  Tablet: '-9px',
                                  Mobile: '-9px',
                                },
                                vertiori: 'bottom',
                                offsetbottom: {
                                  Desktop: '51px',
                                  Tablet: '51px',
                                  Mobile: '51px',
                                },
                                zIndex: {
                                  Desktop: 283582,
                                  Tablet: 283582,
                                  Mobile: 283582,
                                },
                              },
                                                                                          
                            className: `vayu-pin-first-wrap`, // Custom class for this block
                        },
                            [
                                ['vayu-blocks/advance-heading', { 
                                    headingColor: '#FFF',
                                    content: __('Tooltip', 'vayu-blocks'),
                                    fontSize: 16, 
                                    tag: 'p',
                                    advMargin: {
                                        Desktop: {
                                          top: '0px',
                                          right: '0px',
                                          bottom: '0px',
                                          left: '0px',
                                        },
                                        Tablet: {
                                            top: '0px',
                                          right: '0px',
                                          bottom: '0px',
                                          left: '0px',
                                        },
                                        Mobile: {
                                            top: '0px',
                                          right: '0px',
                                          bottom: '0px',
                                          left: '0px',
                                        },
                                      },
                                      typography : {
                                        fonts: {},
                                        fontSize: {
                                        Desktop: '13px',
                                        Tablet: '13px',
                                        Mobile: '13px'
                                        },
                                        appearance: {},
                                        lineHeights: {},
                                        letterSpacing: {},
                                        decoration: {},
                                        orientation: {},
                                        letterCase: {}
                                        },
                                        align:{
                                            Desktop: 'center',
                                            Tablet: 'center',
                                            Mobile: 'center' 
                                        }
                                   
                                }],
                            ]
                        ],
                        ['vayu-blocks/icon', {
                            backgroundcolor: '#000',
                            backgroundhoverColor: '#000',
                            color: '#FFF',
                            hoverColor : '#FFF',
                            iconName: 'wordpress-plusCircle',
                            iconSize:{Desktop:"25px", Tablet:"25px", Mobile: "25px"},
                            iconpadding: {
                                Desktop: {
                                  top: '5px',
                                  right: '5px',
                                  bottom: '5px',
                                  left: '5px',
                                },
                                Tablet: {
                                    top: '5px',
                                    right: '5px',
                                    bottom: '5px',
                                    left: '5px',
                                },
                                Mobile: {
                                    top: '5px',
                                    right: '5px',
                                    bottom: '5px',
                                    left: '5px',
                                },
                              },
                            iconsRadius: {
                                Desktop: {
                                  topLeft: '50px',
                                  topRight: '50px',
                                  bottomLeft: '50px',
                                  bottomRight: '50px',
                                },
                                Tablet: {
                                    topLeft: '50px',
                                    topRight: '50px',
                                    bottomLeft: '50px',
                                    bottomRight: '50px',
                                },
                                Mobile: {
                                    topLeft: '50px',
                                    topRight: '50px',
                                    bottomLeft: '50px',
                                    bottomRight: '50px',
                                },
                              },
                            className: `vayu-pin-second-wrap`, // Custom class for this block

                        }],
                    ]}
                    templateLock={false}
                    
                />
            </div>
        </div>
        </>
    );
}